import React, { Component,Fragment } from 'react';
import {TodoConsumer} from '../../store/todoContext';

class AddContact extends Component {
  
  render() {
    return (
      <TodoConsumer>
        {
          value => {
            const {title,handleChange,handleSubmit,editItem} = value;
            return (
              <Fragment>
                <div className="container">
                  <div className="row">
                    <div className="col-10 mx-auto col-md-8 mt-4">
                      <h3 className="text-capitalize text-center">todo input</h3>
                    </div>
                  </div>
                  <div className="card card-body mb-3">
                    <form onSubmit={handleSubmit}>
                      <div className="input-group ">
                        <div className="input-group-prepend">
                          <div className="input-group-text bg-primary text-white">
                            <i className="fa fa-book"></i>
                          </div>
                          <input type="text" className="form-control" placeholder="add a todo item" value={title} onChange={handleChange} />
                        </div>
                      </div>
                      <button type="submit" className={
                        editItem ? "btn btn-block btn-success mt-3 text-capitalize" : "btn btn-block btn-primary mt-3 text-capitalize"
                      }> 
                        {editItem ? 'edit item' : 'add item'}
                      </button>
                    </form>
                  </div>
                </div>
              </Fragment>
            )
          }
        }
      </TodoConsumer>
    )
  }
}
export default AddContact;
